import { DateTime } from 'luxon';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Period } from 'dashboard/lib/unixTime';
import { Environment } from 'dashboard/models/environment';
import { MetricsApiLogVolumeOverTime } from 'dashboard/models/metrics-api-logs';
import {
  MetricsApiLogFilterParams,
  setMetricsApiLogsPaths,
  setMetricsApiLogsVolumeOverTime,
} from 'dashboard/redux/slices/metrics-api-logs';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export interface ApiLogsVolumeOverTimeResponse {
  meta: MetricsApiLogVolumeOverTime;
  updated_at: Iso8601DateString;
}

function getPeriod(start: Iso8601DateString, end: Iso8601DateString): Period {
  const dayDifferential = DateTime.fromISO(end).diff(DateTime.fromISO(start), 'days').days;
  if (dayDifferential < 1) {
    return Period.Hour;
  } else if (dayDifferential < 28) {
    return Period.Day;
  } else {
    return Period.Week;
  }
}

export const loadMetricsApiLogsVolumeOverTime = (
  currentEnvironment: Environment,
  filters: MetricsApiLogFilterParams,
): DashboardThunkAction => {
  return async (dispatch) => {
    const { createdAtStart, createdAtEnd, apiPaths } = filters;

    const filterParams = {
      'environment-id': currentEnvironment.id,
      'api-paths': JSON.parse(JSON.stringify(apiPaths)),
      'created-at-start': createdAtStart,
      'created-at-end': createdAtEnd,
      period:
        createdAtStart && createdAtEnd ? getPeriod(createdAtStart, createdAtEnd) : Period.Hour,
    };
    const response = await SessionClientDashboard.getEndpoint<ApiLogsVolumeOverTimeResponse>(
      ApiEndpoint.MetricsApiLogsVolumeOverTime,
      {
        filter: filterParams,
      },
    );

    dispatch(
      setMetricsApiLogsVolumeOverTime({
        apiLogsVolumeOverTime: response.meta,
        queriedAt: new Date().toISOString(),
      }),
    );
  };
};

export const loadMetricsApiLogsPaths = (
  currentEnvironment: Environment,
  filters: MetricsApiLogFilterParams,
): DashboardThunkAction => {
  return async (dispatch) => {
    const { createdAtStart, createdAtEnd } = filters;

    const filterParams = {
      'environment-id': currentEnvironment.id,
      'created-at-start': createdAtStart,
      'created-at-end': createdAtEnd,
    };
    const apiLogsPaths = (
      await SessionClientDashboard.getResourceMetaTyped<ApiEndpoint.MetricsApiLogsPaths>(
        ApiEndpoint.MetricsApiLogsPaths,
        {
          filter: filterParams,
        },
      )
    ).meta;

    dispatch(
      setMetricsApiLogsPaths({
        apiLogsPaths,
        queriedAt: new Date().toISOString(),
      }),
    );
  };
};
